







































import { DeviceEnum } from '../enums';

import { UiIconButton } from './keen-ui';

export default {
  name: 'epb-modal',
  props: {
    closable: {
      default: true,
      type: Boolean
    },
    resizable: Boolean,
    fullscreen: Boolean,
    width: {
      type: String,
      default: '720px'
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    UiIconButton
  },
  computed: {
    isResizable: function (): boolean {
      return this.resizable && this.$epb.device > DeviceEnum.MOBILE;
    },
    isFullscreen: function (): boolean {
      return this.fullscreen || this.$epb.device === DeviceEnum.MOBILE;
    }
  },
  data: function () {
    return {
      iconButtonProps: {
        type: 'secondary',
        size: 'mini'
      }
    };
  },
  methods: {
    onResizeClick: function (): void {
      this.$emit('update:fullscreen', !this.fullscreen);
      this.$emit('updateFullscreen', !this.fullscreen);
    }
  }
};
